'use client';

import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// Log environment variable status (only in development)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('Supabase Environment Check:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    url: supabaseUrl ? `${supabaseUrl.substring(0, 20)}...` : 'missing',
    key: supabaseAnonKey ? `${supabaseAnonKey.substring(0, 20)}...` : 'missing'
  });
}

// Create the browser client
export function createClient() {
  // During build time, environment variables might not be available
  if (typeof window === 'undefined' && (!supabaseUrl || !supabaseAnonKey)) {
    console.warn('Supabase environment variables are missing during build');
    return null;
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Supabase environment variables are missing');
    return null;
  }

  return createBrowserClient(supabaseUrl, supabaseAnonKey);
}

// Create a lazy singleton instance for backward compatibility
let _supabaseInstance: ReturnType<typeof createClient> | undefined = undefined;

export const getSupabaseClient = () => {
  if (_supabaseInstance === undefined) {
    _supabaseInstance = createClient();
  }
  return _supabaseInstance;
};

// For backward compatibility - but now it's a function call
export const supabase = getSupabaseClient();

// Helper function to check if Supabase is available
export const isSupabaseAvailable = () => {
  return !!supabaseUrl && !!supabaseAnonKey;
};

// Helper function to get environment status for debugging
export const getSupabaseStatus = () => {
  return {
    isAvailable: isSupabaseAvailable(),
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    clientExists: !!supabase
  };
};


